import { FunctionComponent, ReactElement } from "react";
import Header from "@components/headers/Header";
import Footer from "@components/footers/Footer";

interface DualPageLayoutProps {
  headerActions?: ReactElement;
  leftBodyClassName?: string;
  rightBodyClassName?: string;
  container?: boolean;
  containerSize?: "sm" | "md" | "lg";
  noHeader?: boolean;
  noFooter?: boolean;
  sideMenuClosableOnDesktop?: boolean;
  leftContent: string | ReactElement;
  leftFooterActions?: ReactElement;
  rightContent: string | ReactElement;
  leftPanelOnly?: boolean;
  rightPanelOnly?: boolean;
}

const DualPageLayout: FunctionComponent<DualPageLayoutProps> = ({
  headerActions,
  leftBodyClassName = "",
  rightBodyClassName = "",
  container = true,
  containerSize = "lg",
  noHeader = false,
  noFooter = false,
  sideMenuClosableOnDesktop = false,
  leftContent,
  leftFooterActions,
  rightContent,
  leftPanelOnly = false,
  rightPanelOnly = false,
}) => {
  return (
    <>
      {!noHeader && (
        <Header
          className={
            sideMenuClosableOnDesktop ? "sidemenu-closable-on-desktop" : ""
          }
          actions={headerActions}
        />
      )}
      <div
        className={`d-flex flex-row ${
          container ? `content-contained content-${containerSize}` : ""
        }`}
      >
        {!rightPanelOnly && (
          <aside className={`side-panel ${leftBodyClassName}`}>
            <div className="side-panel-content">{leftContent}</div>
            {leftFooterActions && (
              <div className="side-panel-footer">{leftFooterActions}</div>
            )}
          </aside>
        )}
        {!leftPanelOnly && (
          <main className={`main-panel ${rightBodyClassName}`}>
            {rightContent}
          </main>
        )}
      </div>
      {!noFooter && <Footer />}
    </>
  );
};

export default DualPageLayout;
